import TabsWrapper from './Tabs';

const Tabs = TabsWrapper;

export default Tabs;
